import {observer} from "mobx-react";
import {IGameContextViewModel} from "../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {useServices} from "../../../react-hooks/use-services.hook";
import {GameJackpotBarComponent} from "./game-jackpot-bar.component";

interface IGameJackpotBarComponentGenericProps {
    gameContext: IGameContextViewModel;
}

export const GameJackpotBarGenericComponent: React.FC<IGameJackpotBarComponentGenericProps> = observer((props) => {
    const services = useServices();

    if (services.jackpotBet.isEnabled || services.magic8ball.shouldRenderBall) {
        if (props.gameContext.gameInfo.hasJackpotBet && !props.gameContext.freePlayContext.isFreePlay) {
            return <GameJackpotBarComponent gameContext={props.gameContext} />;
        }
    }

    return null;
});
